import { breadcrumb } from './breadcrumb/breadcrumb.module';
import { sidebar } from './sidebar/sidebar.module';
import { overviewTemplate } from './overview-template/overview-template.module';
import { displayOverview } from './display-overview/display-overview.module';
import { uploadCoverPic } from './upload-cover-pic/upload-cover-pic.module';
import { modal } from './modal/modal.module';
import { displayCoverPic } from './display-cover-pic/display-cover-pic.module';
import { displaySquarePic } from './display-square-pic/display-square-pic.module';
import { formButtons } from './form-buttons/form-buttons.module';
import { inputValidation } from './input-validation/input-validation.module';
import { contentSequence } from './content-sequence/content-sequence.module';
import { autocomplete } from './autocomplete/autocomplete.module';
import { phoneTemplate } from './phone-template/phone-template.module';
import { highmaps } from './highmaps/highmaps.module';
import { basicInfo } from './basic-info/basic-info.module';
import { serviceInfo } from './service-info/service-info.module';
import { operationInfo } from './operation-info/operation-info.module';
import { otherInfo } from './other-info/other-info.module';
import { tag } from './tag/tag.module';
import { checkboxTemplate1 } from './checkbox-template1/checkbox-template1.module';
import { timepicker } from './timepicker/timepicker.module';
import { pagination } from './pagination/pagination.module';
import { daysOfOperation } from './days-of-operation/days-of-operation.module';
import { contentTemplate } from './content-template/content-template.module';
import { pageStatus } from './page-status/page-status.module';
import { characterCount } from './character-count/character-count.module';
import { featureMainPageTemplate } from './feature-main-page-template/feature-main-page-template.module';
import { reportRepository } from './report-repository/report-repository.module';
import { emptyTextValidation } from './empty-text-validation/empty-text-validation.module';
import { subFeatureRepository } from './sub-feature-repository/sub-feature-repository.module';
import { selectDropdown } from './select-dropdown/select-dropdown.module';
import { datepicker } from './datepicker/datepicker.module';
import { searchBox } from './search-box/search-box.module';
import { pageContentCount } from './page-content-count/page-content-count.module';
import { googleLocation } from './google-location/google-location.module';
import { editor } from './editor/editor.module';
import { radioButtons } from './radio-buttons/radio-buttons.module';
import { checkbox } from './checkbox/checkbox.module';
import { address } from './address/address.module';

export const components = angular
    .module('common.components', [
        breadcrumb,
        sidebar,
        overviewTemplate,
        displayOverview,
        uploadCoverPic,
        modal,
        displayCoverPic,
        displaySquarePic,
        formButtons,
        inputValidation,
        contentSequence,
        autocomplete,
        phoneTemplate,
        highmaps,
        basicInfo,
        serviceInfo,
        operationInfo,
        otherInfo,
        tag,
        checkboxTemplate1,
        timepicker,
        pagination,
        daysOfOperation,
        contentTemplate,
        pageStatus,
        characterCount,
        featureMainPageTemplate,
        reportRepository,
        emptyTextValidation,
        subFeatureRepository,
        emptyTextValidation,
        selectDropdown,
        datepicker,
        searchBox,
        pageContentCount,
        googleLocation,
        editor,
        radioButtons,
        checkbox,
        address
    ])
    .name;


// WEBPACK FOOTER //
// ./src/app/common/components/components.module.js